import { render, staticRenderFns } from "./valueAssessment.vue?vue&type=template&id=796f36e9&scoped=true"
import script from "./valueAssessment.vue?vue&type=script&lang=js"
export * from "./valueAssessment.vue?vue&type=script&lang=js"
import style0 from "./valueAssessment.vue?vue&type=style&index=0&id=796f36e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f36e9",
  null
  
)

export default component.exports